import { useState } from "react";
import {
  RequestGetSettingRequest,
  SettingGetSettingPostRequest,
  SettingApi,
  ResponseGetSettingResponse,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetBaseSetting = () => {
  const [result, setResult] = useState<ResponseGetSettingResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getBaseSetting = async (req: RequestGetSettingRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: SettingGetSettingPostRequest = {
        req,
      };

      const api = new SettingApi(config);
      const response = await api.settingGetSettingPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { getBaseSetting, error, isLoading };
};
